<!-- ALERT TOAST-->
<p-toast></p-toast>

<!-- CONFIRMATION DIALOG-->
<p-confirmDialog [style]="{width: '450px'}"></p-confirmDialog>

<!-- OVERLAY SCREEN-->
<div *ngIf="blocked " class="overlay">
    <img src="assets/layout/images/tovlogo.png" alt="Loading Icon" class="loading-image" />
    <span style="color: white; font-size: large;">{{translations.lbl_loading}}</span>
</div>

<!-- MAIN SCREEN -->
<div class="card">

    <!-- GO BACK BUTTON -->
    <p-toolbar styleClass="p-mb-4">
        <ng-template pTemplate="left">
            <button pButton pRipple label="{{translations.lbl_back}}" icon="pi pi-chevron-left"
                class="p-button-warning p-mr-2" (click)="goBack()"></button>
            <button pButton pRipple label="{{capitalizeFirstLetter(translations.lbl_send)}} {{translations.lbl_file}}"
                icon="pi pi-upload" class="p-button-success p-mr-2" (click)="uploadGuides()"
                *ngIf="!haserrors"></button>
        </ng-template>
    </p-toolbar>

    <!-- MAIN CONTENT -->
    <div class="p-grid">

        <div class="p-col-12 p-md-6">
            <p-panel>
                <!-- COORDINATION FORM -->
                <div class="p-xl-12 p-lg-12 p-md-12 p-sm-12 p-xs-12">
                    <!-- INPUT FILE -->
                    <p-fileUpload chooseLabel="Seleccione excel" uploadLabel="Cargar" cancelLabel="Cancelar"
                        name="demo[]" [customUpload]="true" (uploadHandler)="onFileSelect($event)"
                        (onClear)="clearTable()"
                        accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel">
                        <ng-template pTemplate="content">
                            <ul *ngIf="uploadedFiles.length">
                                <li *ngFor="let file of uploadedFiles">
                                    <i class="pi pi-file" style="margin-right: 8px;"></i>
                                    {{file.name}} - {{file.size}} bytes
                                </li>
                            </ul>
                        </ng-template>
                    </p-fileUpload>
                </div>
            </p-panel>
        </div>
    </div>

    <br />
    <!-- TAB VIEW -->
    <p-tabView *ngIf="listExternGuides && listExternGuides.length > 0 ">

        <!-- TAB PANEL -->
        <p-tabPanel
            [header]="capitalizeFirstLetter(translations.lbl_send) + ' ' +  translations.lbl_file + ' ' + translations.lbl_guides  + ' a TOV ' + translations.lbl_zonal_coordination + ' ' + translations.lbl_international ">

            <p-table #dt [value]="listExternGuides" [rows]="10" [paginator]="true"
                [globalFilterFields]="['guideId','guideName','email']" [rowHover]="true" dataKey="guideId"
                currentPageReportTemplate="{{translations.lbl_showing}} {first} {{translations.lbl_to}} {last} {{translations.lbl_of}} {totalRecords} {{translations.lbl_records}}"
                [showCurrentPageReport]="true" [scrollable]="true" [style]="{width:'130rem'}" scrollHeight="400px"
                scrollDirection="both" responsive="true">

                <!-- CAPTION TABLE -->
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-ai-left p-jc-between responsive">
                        <div>

                        </div>

                        <div class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                placeholder="{{translations.lbl_search}}..." />
                        </div>
                    </div>
                </ng-template>

                <!-- HEADER -->
                <ng-template pTemplate="header">
                    <tr>
                        <th pSortableColumn="guideId" style="width:9rem" pTooltip="{{capitalizeFirstLetter(translations.lbl_certificate)!}} /
                        {{capitalizeFirstLetter(translations.lbl_id)}}" tooltipPosition="top">
                            {{capitalizeFirstLetter(translations.lbl_certificate)!}} /
                            {{capitalizeFirstLetter(translations.lbl_id)}}<p-sortIcon field="guideId"></p-sortIcon>
                        </th>
                        <th pSortableColumn="guideName" style="width:9rem"
                            pTooltip="{{capitalizeFirstLetter(translations.lbl_name)!}}" tooltipPosition="top">
                            {{translations.lbl_name}}<p-sortIcon field="guideName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="lastName" style="width:9rem" pTooltip="{{translations.lbl_last_name}}"
                            tooltipPosition="top">{{translations.lbl_last_name}}<p-sortIcon
                                field="lastName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="email" style="width:15rem" pTooltip="{{translations.lbl_email}}"
                            tooltipPosition="top">
                            <div class="p-d-flex p-jc-even p-ai-center">
                                {{translations.lbl_email}}
                                <p-sortIcon field="email"></p-sortIcon>
                                <p-columnFilter type="boolean" field="isValidEmail" display="menu"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="mobilePhone" style="width:9rem" pTooltip="{{translations.lbl_cell_phone}}"
                            tooltipPosition="top">{{translations.lbl_cell_phone}}<p-sortIcon
                                field="mobilePhone"></p-sortIcon>
                        </th>
                        <th pSortableColumn="otherPhone" style="width:9rem"
                            pTooltip="{{translations.lbl_others}} {{translations.lbl_cell_phone}}"
                            tooltipPosition="top">{{translations.lbl_others}}
                            {{translations.lbl_cell_phone}}<p-sortIcon field="otherPhone"></p-sortIcon>
                        </th>
                        <th pSortableColumn="guideType" style="width:9rem" tooltipPosition="top"
                            pTooltip="{{capitalizeFirstLetter(translations.lbl_status)}}">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{capitalizeFirstLetter(translations.lbl_status)}}
                                <p-sortIcon field="guideType"></p-sortIcon>
                                <p-columnFilter type="boolean" field="isValidStatusGuide"
                                    display="menu"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="nationality" style="width:9rem" pTooltip="{{translations.lbl_nationality}}"
                            tooltipPosition="top">{{translations.lbl_nationality}}<p-sortIcon field="nationality">
                            </p-sortIcon>
                        </th>
                        <th pSortableColumn="residenCountry" style="width:9rem" tooltipPosition="top"
                            pTooltip="{{translations.lbl_country}}">{{translations.lbl_country}}<p-sortIcon
                                field="residenCountry"></p-sortIcon>
                        </th>
                        <th pSortableColumn="zone" style="width:9rem" pTooltip="{{translations.lbl_zonal_coordination}}"
                            tooltipPosition="top">
                            {{translations.lbl_zonal_coordination}}<p-sortIcon field="zone"></p-sortIcon>
                        </th>
                        <th pSortableColumn="national" style="width:9rem" tooltipPosition="top"
                            pTooltip="{{translations.lbl_national}}">{{translations.lbl_national}}<p-sortIcon
                                field="national"></p-sortIcon>
                        </th>
                        <th pSortableColumn="local" style="width:9rem" tooltipPosition="top"
                            pTooltip="{{translations.lbl_local_coordination}}">
                            {{translations.lbl_local_coordination}}<p-sortIcon field="local"></p-sortIcon>
                        </th>
                        <th pSortableColumn="natioName" style="width:9rem" tooltipPosition="top"
                            pTooltip="{{translations.lbl_country}}  {{translations.lbl_local_coordination}}">
                            {{translations.lbl_country}}
                            {{translations.lbl_local_coordination}}<p-sortIcon field="natioName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="zoneName" style="width:9rem" tooltipPosition="top"
                            pTooltip="{{translations.lbl_cities_states}} {{translations.lbl_local_coordination}}">
                            {{translations.lbl_cities_states}}
                            {{translations.lbl_local_coordination}}<p-sortIcon field="zoneName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="zoneName" style="width:9rem" tooltipPosition="top"
                            pTooltip="{{translations.lbl_cities_states}} {{translations.lbl_local_coordination}}">
                            {{translations.lbl_cities_states}}
                            {{translations.lbl_local_coordination}}<p-sortIcon field="zoneName"></p-sortIcon>
                        </th>
                        <th pSortableColumn="currentRole" style="width:9rem" tooltipPosition="top"
                            pTooltip="{{translations.lbl_function}}">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{translations.lbl_function}} <p-sortIcon field="currentRole"></p-sortIcon>
                                <p-columnFilter type="boolean" field="isValidFunction" display="menu"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="currentLevel" style="width:9rem" tooltipPosition="top"
                            pTooltip="{{translations.lbl_level}} {{translations.lbl_function}}">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{translations.lbl_level}} {{translations.lbl_function}} <p-sortIcon
                                    field="currentLevel"></p-sortIcon>
                                <p-columnFilter type="boolean" field="isValidlevel" display="menu"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="zoneExperience" style="width:9rem" tooltipPosition="top"
                            pTooltip="{{translations.lbl_any_zone_team_experience}}">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{translations.lbl_any_zone_team_experience}}
                                <p-sortIcon field="zoneExperience"></p-sortIcon>
                                <p-columnFilter type="boolean" field="isValidExperZone" display="menu"></p-columnFilter>
                            </div>
                        </th>
                        <th pSortableColumn="natioExperience" style="width:9rem" tooltipPosition="top"
                            pTooltip="{{translations.lbl_any_natio_team_experience}}">
                            {{translations.lbl_any_natio_team_experience}}<p-sortIcon
                                field="natioExperience"></p-sortIcon><p-columnFilter type="boolean"
                                field="isValidExperNac" display="menu"></p-columnFilter>
                        </th>
                        <th pSortableColumn="sendingYear" style="width:9rem" tooltipPosition="top"
                            pTooltip="{{translations.lbl_sent_year}}">{{translations.lbl_sent_year}}<p-sortIcon
                                field="sendingYear"></p-sortIcon>
                        </th>
                        <th pSortableColumn="sendingMonth" style="width:9rem" tooltipPosition="top"
                            pTooltip="Mes Envío">Mes Envío
                            <p-sortIcon field="sendingMonth"></p-sortIcon>
                        </th>
                        <th pSortableColumn="sendingDay" style="width:9rem" tooltipPosition="top"
                            pTooltip="{{capitalizeFirstLetter(translations.lbl_sent)}}">
                            {{capitalizeFirstLetter(translations.lbl_sent)}}
                            {{translations.lbl_day}}<p-sortIcon field="sendingDay"></p-sortIcon>
                        </th>
                        <th pSortableColumn="maleFemale" style="width:9rem" tooltipPosition="top"
                            pTooltip="{{translations.lbl_gender}}">{{translations.lbl_gender}}<p-sortIcon
                                field="maleFemale"></p-sortIcon>
                        </th>
                        <th pSortableColumn="currentJob" style="width:9rem" tooltipPosition="top"
                            pTooltip="{{translations.lbl_current_job}}">{{translations.lbl_current_job}}<p-sortIcon
                                field="currentJob"></p-sortIcon>
                        </th>
                        <th pSortableColumn="spokenlanguage" style="width:9rem" tooltipPosition="top"
                            pTooltip="{{translations.lbl_language}}">{{translations.lbl_language}}<p-sortIcon
                                field="spokenlanguage"></p-sortIcon>
                        </th>
                        <th pSortableColumn="countryAddress" style="width:9rem" tooltipPosition="top"
                            pTooltip="{{translations.lbl_address}} {{translations.lbl_country}}">
                            {{translations.lbl_address}}
                            {{translations.lbl_country}}<p-sortIcon field="countryAddress"></p-sortIcon>
                        </th>
                        <th pSortableColumn="stateAddress" style="width:9rem" tooltipPosition="top"
                            pTooltip="{{translations.lbl_address}} {{translations.lbl_state}}">
                            {{translations.lbl_address}}
                            {{translations.lbl_state}}<p-sortIcon field="stateAddress"></p-sortIcon>
                        </th>
                        <th pSortableColumn="cityAddress" style="width:9rem" tooltipPosition="top"
                            pTooltip="{{translations.lbl_address}} {{translations.lbl_city}}">
                            {{translations.lbl_address}}
                            {{translations.lbl_city}}<p-sortIcon field="cityAddress"></p-sortIcon>
                        </th>
                        <th pSortableColumn="birthYear" style="width:9rem" tooltipPosition="top"
                            pTooltip="{{translations.lbl_birth_day}}">{{translations.lbl_birth_day}}<p-sortIcon
                                field="birthYear"></p-sortIcon>
                        </th>
                        <th pSortableColumn="brithMonth" style="width:9rem" tooltipPosition="top"
                            pTooltip="{{translations.lbl_birth_month}}">{{translations.lbl_birth_month}}<p-sortIcon
                                field="brithMonth"></p-sortIcon>
                        </th>
                        <th pSortableColumn="birthDay" style="width:9rem" tooltipPosition="top"
                            pTooltip="{{translations.lbl_birth_year}}">{{translations.lbl_birth_year}}<p-sortIcon
                                field="birthDay"></p-sortIcon>
                        </th>
                    </tr>
                </ng-template>

                <!-- BODY -->
                <ng-template pTemplate="body" let-gui>
                    <tr>
                        <td style="width:9rem">{{gui.guideId}}</td>
                        <td style="width:9rem">{{gui.guideName}}</td>
                        <td style="width:9rem">{{gui.lastName}}</td>
                        <td style="width:15rem">
                            <div [ngClass]="{'invalidGuide': gui.isValidEmail === false}">
                                <i class="pi" [ngClass]="{'false-icon pi-times-circle': !gui.isValidEmail}"></i>
                                {{gui.email}}
                            </div>
                        </td>

                        <td style="width:9rem">{{gui.mobilePhone}}</td>
                        <td style="width:9rem">{{gui.otherPhone}}</td>
                        <td style="width:9rem">
                            <div [ngClass]="{'invalidGuide': gui.isValidStatusGuide === false}">
                                <i class="pi" [ngClass]="{'false-icon pi-times-circle': !gui.isValidStatusGuide}"></i>
                                {{gui.guideType}}
                            </div>
                        </td>
                        <td style="width:9rem">{{gui.nationality}}</td>
                        <td style="width:9rem">{{gui.residenCountry}}</td>
                        <td style="width:9rem">{{gui.zone}}</td>
                        <td style="width:9rem">{{gui.national}}</td>
                        <td style="width:9rem">{{gui.local}}</td>
                        <td style="width:9rem">{{gui.localCountry}}</td>
                        <td style="width:9rem">{{gui.localState}}</td>
                        <td style="width:9rem">{{gui.localCity}}</td>
                        <td style="width:9rem">
                            <div [ngClass]="{'invalidGuide': gui.isValidFunction === false}">
                                <i class="pi" [ngClass]="{'false-icon pi-times-circle': !gui.isValidFunction}"></i>
                                {{gui.currentRole}}
                            </div>
                        </td>

                        <td style="width:9rem">
                            <div [ngClass]="{'invalidGuide': gui.isValidlevel === false}">
                                <i class="pi" [ngClass]="{'false-icon pi-times-circle': !gui.isValidlevel}"></i>
                                {{gui.currentLevel}}
                            </div>
                        </td>
                        <td style="width:9rem">
                            <div [ngClass]="{'invalidGuide': gui.isValidExperZone === false}">
                                <i class="pi" [ngClass]="{'false-icon pi-times-circle': !gui.isValidExperZone}"></i>
                                {{gui.zoneExperience}}
                            </div>
                        </td>
                        <td style="width:9rem">
                            <div [ngClass]="{'invalidGuide': gui.isValidExperNac === false}">
                                <i class="pi" [ngClass]="{'false-icon pi-times-circle': !gui.isValidExperNac}"></i>
                                {{gui.natioExperience}}
                            </div>
                        </td>
                        <td style="width:9rem">{{gui.sendingYear}}</td>
                        <td style="width:9rem">{{gui.sendingMonth}}</td>
                        <td style="width:9rem">{{gui.sendingDay}}</td>
                        <td style="width:9rem">
                            <div [ngClass]="{'invalidGuide': gui.isValidGender === false}">
                                <i class="pi" [ngClass]="{'false-icon pi-times-circle': !gui.isValidGender}"></i>
                                {{gui.maleFemale}}
                            </div>
                        </td>
                        <td style="width:9rem">{{gui.currentJob}}</td>
                        <td style="width:9rem">{{gui.spokenlanguage}}</td>
                        <td style="width:9rem">{{gui.countryAddress}}</td>
                        <td style="width:9rem">{{gui.stateAddress}}</td>
                        <td style="width:9rem">{{gui.cityAddress}}</td>
                        <td style="width:9rem">{{gui.birthYear}}</td>
                        <td style="width:9rem">{{gui.brithMonth}}</td>
                        <td style="width:9rem">{{gui.birthDay}}</td>
                    </tr>
                </ng-template>

                <!-- EMPTY -->
                <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                        <td [attr.colspan]="columns ? columns.length : 1">
                            {{translations.lbl_no_records_found}}
                        </td>
                    </tr>
                </ng-template>

                <!-- SUMMARY -->
                <ng-template pTemplate="summary">
                    <div class="flex align-items-center justify-content-between">
                        {{translations.lbl_total}} {{translations.lbl_there_are}} {{listImportGuides ?
                        listImportGuides.length :
                        0 }} {{translations.lbl_records}}
                    </div>
                </ng-template>
            </p-table>



        </p-tabPanel>
    </p-tabView>
</div>